import { HStack, VStack, Text, FormControl } from "@gluestack-ui/themed";
import { Controller } from "react-hook-form";
import { InputType, InputTypeSelectControlledProps } from "./types";
import { Button } from "@repo/core/components/core/Button";
import { InputLabel } from "@repo/core/components/core/Input/components/InputLabel";
import { useDimensions } from "@repo/core/hooks/useDimensions";

export const InputTypeSelectControlled = ({
  name,
  control,
  inputTypes,
  label,
  isRequired,
  isFullWidth,
  defaultValue,
  isClickable = true,
  onChange
}: InputTypeSelectControlledProps) => {
  const { isMobile } = useDimensions();

  return (
    <Controller
      defaultValue={defaultValue}
      control={control}
      name={name}
      render={({
        field: { onChange: onChangeField, value },
        fieldState: { error }
      }) => {
        return (
          <FormControl isInvalid={!!error?.message} isRequired={isRequired}>
            <VStack>
              <InputLabel label={label} isRequired={isRequired} />
              <HStack gap={8} flexWrap="wrap" w="$full">
                {inputTypes.map((inputType: InputType) => (
                  <Button
                    minWidth="$20"
                    width={isFullWidth ? "$20" : undefined}
                    flexShrink={0}
                    key={inputType.value}
                    variant={value === inputType.value ? "solid" : "outline"}
                    action={
                      value === inputType.value
                        ? "secondary"
                        : "darker-secondary"
                    }
                    isDisabled={!isClickable}
                    onPress={
                      isClickable
                        ? () => {
                            onChangeField(inputType.value);
                            onChange?.(inputType.value);
                          }
                        : undefined
                    }
                    textStyle={{ fontSize: isMobile ? "$sm" : "$md" }}
                    text={inputType.label}
                  />
                ))}
              </HStack>
              {error?.message && (
                <Text fontSize="$xs" color="$error700" mt="$1">
                  {error.message}
                </Text>
              )}
            </VStack>
          </FormControl>
        );
      }}
    />
  );
};
